import { cn } from '@/lib/utils'
import type { BlockContext } from './types'
import { useMessages } from '@/i18n'
import { messages } from './sidebarMessages'

interface Props {
  context: BlockContext
  /** badge — над сообщением пользователя, chip — над полем ввода (реф-размеры). */
  variant: 'badge' | 'chip'
}

export const BlockContextChip = ({ context, variant }: Props) => {
  const m = useMessages(messages)
  const Icon = context.icon
  const isBadge = variant === 'badge'

  return (
    <div
      className={cn(
        'flex items-center border bg-[hsl(var(--mode-edit-bg)/0.6)]',
        'border-[hsl(var(--mode-edit-fg)/0.3)]',
        isBadge ? 'gap-1.5 rounded-lg px-2.5 py-1' : 'gap-2 rounded-xl px-3 py-1.5',
      )}
    >
      <Icon
        className={cn(
          'flex-shrink-0 text-[hsl(var(--mode-edit-fg))]',
          isBadge ? 'h-3 w-3' : 'h-3.5 w-3.5',
        )}
      />
      <span
        className={cn(
          'truncate font-medium text-[hsl(var(--mode-edit-fg))]',
          isBadge ? 'text-[11px]' : 'text-xs',
        )}
      >
        {context.lessonOrder && context.blockOrder
          ? m.lessonBlockPrefix(context.lessonOrder, context.blockOrder)
          : ''}
        {context.label}
      </span>
    </div>
  )
}
